import {ItemDto} from '../../../../models/Items/IItem';
import {IRecipe} from '../../../../models/Recipe/IRecipe';
import {GuidLightDto} from '../../../../models/common/IGuidLight';
import RecipeForm from '../../shared/RecipeForm';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

interface Props { recipeData: IRecipe; fillings?: GuidLightDto[]; productTypes?: GuidLightDto[]; items?: ItemDto[]; onSubmit: (value: IRecipe) => Promise<void>; }
export const EditRecipe = ({recipeData, fillings, productTypes, items, onSubmit}: Props) => {
    const {t} = useAppTranslation();
    return <RecipeForm initialData={recipeData} fillings={fillings} productTypes={productTypes} items={items} onSubmit={onSubmit} submitLabel={t('recipes:save_recipe')}/>;
};
